window.addEventListener('load', (event) => {
  var rateCountCont = document.querySelector('.fera-productReviewsSummary-reviewCount');
  var rateCount = rateCountCont.getAttribute('data-value');

  if (rateCount > 1 ) {
    rateCountCont.innerText = rateCount + ' reviews';
  } else {
    rateCountCont.innerText = rateCount + ' review';
  }

  rateCountCont.classList.add('show');
});